import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { getUser } from '../actions/getUser';

export const getUserQueryKey = (sourcedId: string) => ['user', sourcedId];

export const getUserQueryOptions = (sourcedId: string) => {
  return queryOptions({
    queryKey: getUserQueryKey(sourcedId),
    staleTime: 0, // always fetch fresh data

    placeholderData: keepPreviousData, // don't have 0 rows flash while changing pages/loading next page
    queryFn: async () => {
      const response = await getUser({
        data: {
          sourcedId,
        },
      });

      if (!response.success || response.error) {
        throw new Error(response.error || 'Unknown error');
      }

      return response.data;
    },
  });
};

export const useGetUser = (sourcedId: string) =>
  useQuery(getUserQueryOptions(sourcedId));
